import React, { useState, useCallback, useEffect, useMemo, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AddUserModal } from '../../components/Modal/Employees/AddUserModal';
import { EditUserModal } from '../../components/Modal/Employees/EditUserModal';
import styles from "../../styles/pages/Employees/Employees.module.css";
import { Title } from '../../components/UI/Custom/Title';
import { EmployeeTable } from './components/EmployeeTable';
import { EmpoyeeDesk } from './components/EmpoyeeDesk';
import { FilterModal } from '../../components/Modal/Employees/Modal/FilterModal';
import { getMyAccountApi } from '../../utils/api/Account/getMyAccountApi';
import { LoadingCircle } from '../../components/UI/Custom/LoadingCircle';
import { handleError } from '../../utils/custom/errorHandler';
import { saveWithTTL, getWithTTL } from '../../utils/custom/localStorageTTL';
import { LangContext } from '../../context/LangContext';
import { isSuperAdminIpAdmin } from '../../utils/custom/telegramNotificationsAccess';
import { isLoginAsActive } from '../../utils/custom/loginAsSession';

const BASE_EMPLOYEE_STORAGE_KEY = 'employeeFiltersState';
const translations = {
    ru: {
        title: 'Управление сотрудниками',
    },
    en: {
        title: 'Employee Management',
    },
};

export const EmployeesPage = () => {
    const { langSelected } = useContext(LangContext);
    const t = translations[langSelected] || translations.ru;
    const currentRole = 'admin';
    const EMPLOYEE_STORAGE_KEY_WITH_ROLE = `${BASE_EMPLOYEE_STORAGE_KEY}_${currentRole}`;

    const [isAction, setIsAction] = useState({
        editUserModal: false,
        newUserModal: false,
        newPositionModal: false,
        filterModal: false,
    });
    const [userId, setUserId] = useState(null);
    const [shouldUpdateEmployees, setShouldUpdateEmployees] = useState(false);
    const [filters, setFilters] = useState(() => getWithTTL(EMPLOYEE_STORAGE_KEY_WITH_ROLE));
    const [permissions, setPermissions] = useState({});
    const [isPermissionsLoaded, setIsPermissionsLoaded] = useState(false);
    const [errors, setErrors] = useState({});
    const [canLoginAsAdmins, setCanLoginAsAdmins] = useState(false);
    const [currentAdminId, setCurrentAdminId] = useState(null);

    useEffect(() => {
        console.log(permissions)
    }, [permissions])

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const accountData = await getMyAccountApi();
                if (accountData && accountData.permissions) {
                    setCurrentAdminId(accountData.id || null);
                    setCanLoginAsAdmins(
                        isSuperAdminIpAdmin(accountData) && !isLoginAsActive()
                    );

                    const allPermissions = accountData.permissions;

                    const targetGroups = [
                        "user.admin_accounts_management",
                        "user.desks_management",
                        "user.admin.roles_management"
                    ];

                    const filteredPermissions = allPermissions.filter(
                        (permission) => targetGroups.includes(permission.group)
                    );

                    const permissionsObject = filteredPermissions.reduce((acc, permission) => {
                        acc[permission.name] = permission;
                        return acc;
                    }, {});

                    setPermissions(permissionsObject);
                    console.log('Загруженные разрешения (объект):', permissionsObject);
                }
            } catch (error) {
                console.error('Ошибка при получении данных аккаунта или разрешений:', error);
                handleError(error.response?.data || error, setErrors);
            } finally {
                setIsPermissionsLoaded(true);
            }
        };

        fetchPermissions();
    }, []);

    const handleApplyFilters = useCallback((newFilters) => {
        setFilters(newFilters);
        saveWithTTL(EMPLOYEE_STORAGE_KEY_WITH_ROLE, newFilters);
        setIsAction(prevState => ({ ...prevState, filterModal: false }));
    }, [EMPLOYEE_STORAGE_KEY_WITH_ROLE]);

    useEffect(() => {
        console.log(filters);
    }, [filters]);

    useEffect(() => {
        console.log(isAction);
    }, [isAction]);

    const handlenewUserModal = useCallback(() => {
        setIsAction(prevState => ({ ...prevState, newUserModal: !prevState.newUserModal }));
    }, []);

    const handleEditUserModal = useCallback((id) => {
        setIsAction(prevState => ({ ...prevState, editUserModal: !prevState.editUserModal }));
        setUserId(id);
    }, []);

    const handleneOpenModal = useCallback(() => {
        setIsAction(prevState => ({ ...prevState, filterModal: !prevState.filterModal }));
    }, []);

    const handleUserUpdatedAndCloseEditModal = useCallback(() => {
        setShouldUpdateEmployees(prevState => !prevState);
        setIsAction(prevState => ({ ...prevState, editUserModal: false }));
    }, []);

    const handleUserAddedAndCloseNewUserModal = useCallback(() => {
        setShouldUpdateEmployees(prevState => !prevState);
        handlenewUserModal();
    }, [handlenewUserModal]);

    const currentFilters = useMemo(() => {
        return filters;
    }, [filters]);

    useEffect(() => {
        console.log(permissions)
    }, [permissions])

    if (!isPermissionsLoaded) {
        return (
            <div className={styles.loadingOverlay}>
                <LoadingCircle size={40} thickness={3} />
            </div>
        );
    }

    if (Object.keys(permissions).length === 0) {
        return (
            <div className={styles.container} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', fontSize: '24px', color: '#888' }}>
                Доступ на просмотр страницы сотрудников отсутствует
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <Title h2={t.title} activeSpan={false} />
            <div className={styles.contentWrapper}>
                <EmployeeTable
                    handlenewUserModal={handlenewUserModal}
                    handleEditUserModal={handleEditUserModal}
                    handleneOpenModal={handleneOpenModal}
                    shouldUpdate={shouldUpdateEmployees}
                    filters={filters}
                    permissions={permissions}
                    canLoginAsAdmins={canLoginAsAdmins}
                    currentAdminId={currentAdminId}
                />
                <EmpoyeeDesk
                    permissions={permissions}
                />
            </div>
            {isAction.editUserModal && <EditUserModal
                id={userId}
                handleEditUserModal={handleEditUserModal}
                onUserUpdated={handleUserUpdatedAndCloseEditModal}
                permissions={permissions}
            />}
            {isAction.newUserModal && <AddUserModal
                handlenewUserModal={handlenewUserModal}
                onUserAdded={handleUserAddedAndCloseNewUserModal}
                permissions={permissions}

            />}
            {isAction.filterModal && <FilterModal
                handleneOpenModal={handleneOpenModal}
                setFilters={setFilters}
                currentFilters={filters}
                onApplyFilters={handleApplyFilters}
                role={currentRole}
            />}
        </div>
    );
};
